import { render, staticRenderFns } from "./bdd-tabs.vue?vue&type=template&id=62a27221"
import script from "./bdd-tabs.vue?vue&type=script&lang=js"
export * from "./bdd-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports